import React from "react";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import mapImage from "../../assets/images/img_map.png";
import spriteImage from '../../assets/images/sprite.png';
import arrow from '../../assets/images/sprite_arrow.png';
import mMap from "../../assets/images/m-map.jpg";
import {useMediaQuery} from "react-responsive";
import {device} from "../../assets/styles/media";


const Contents = styled.div`
    margin-bottom: 140px;

    ${device.mobile} {
        margin-bottom: 50px;
    }
`;

const Section = styled.section`
    position: relative;
`;
const Map = styled.img`
    width: 100%;
    max-width: 1440px;
    height: auto;
    margin-bottom: 30px;
`;
const MapInfo = styled.div`
    margin-bottom: 140px;
    ${device.mobile} {
        margin-bottom: 50px;
    }
`;
const MapTitle = styled.strong`
    display: block;
    margin-bottom: 24px;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 15px;
    font-weight: bold;
    font-size: 26px;
    color: #000;

    ${device.mobile} {
        font-size: 18px;
    }
`;
const ContactBox = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 15px;
    margin-bottom: 20px;
    ${device.mobile} {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }
`;
const FlexBox = styled.div`
    display: flex;
    gap: 80px;

    dl:nth-child(2n) {
        dd::before {
            visibility: hidden;
        }
    }

    ${device.tablet}{
        flex-direction: column;
        gap: 20px;
    }
    
    
    ${device.mobile} {
        flex-direction: column;
        gap: 0;
        max-width: 100vw;
        width: 100%;
    }
`;

const InfoBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 7px;
    ${device.mobile} {
        gap: 0;
    }
`;

const AddressBox = styled(InfoBox)``;

const StyledDl = styled.dl`
    font-size: ${({fontSize}) => fontSize || "18px"};
    position: relative;
    padding-left: ${({withDivider}) => (withDivider ? "15px" : "0")};
    margin-top: ${({isLast}) => (isLast ? "4px" : "0")};
    font-weight: 500;

    &::before {
        content: "";
        position: absolute;
        top: 4px;
        left: 0;
        display: ${({withDivider}) => (withDivider ? "inline-block" : "none")};
        width: 1px;
        height: 20px;
        background: #cfd4e0;
    }
    
    ${device.mobile} {
        font-size: 14px;
        padding-left: 0;
        &::before {
            display: none;
        }
    }
`;

const IconDd = styled.dd`
    display: flex;
    align-items: center;
    font-size: inherit;

    &::before {
        content: "";
        display: inline-block;
        margin-right: 10px;
        width: 24px;
        height: 24px;
        background-image: url(${spriteImage});
        background-size: 418px 402px;
        background-position: ${({position}) => position};
    }
    
    
    ${device.mobile} {
        font-size: 13px;
        &::before {
            margin-right: 5px;
            transform: scale(0.7);
        }
    }
`;

const EmailLink = styled.a`
    font-size: inherit;
    ${device.mobile} {
        font-size: 13px;
        font-weight: 500;
    }
`;

const RouteItem = styled.span`
    font-size: 18px;
    display: inline-flex;
    align-items: center;
      white-space: pre-wrap;
    &::after {
        margin: 0 2px;
        content: "";
        display: inline-block;
        background-size: cover;
        width: 13px;
        height: 13px;
        background-image: url(${arrow});
    }
    &:first-child,
    &:last-child {
        &::after {
            display: none;
        }
    }
    
    ${device.mobile} {
        font-size: 13px;
        &::after {
            margin: 0 4px;
            width: 7px;
            height: 7px;
        }
    }
`;

const Location = () => {
    const isTablet = useMediaQuery({maxWidth: 1023});
    const contactData = [
        {
            position: '-378px -324px',
            type: "email",
            value: "dforest@dforest.co.kr",
            link: "mailto:dforest@dforest.co.kr"
        },
        {position: '-378px -350px', type: "phone", value: "033-913-1400"},
        {position: '0 -378px', type: "fax", value: "033-913-1420"},
    ];

    const addressData = [
        {position: '-378px -272px', type: "도로명", value: "강원도 춘천시 남산면 충효로 437"},
        {position: '-378px -272px', type: "지번", value: "강원도 춘천시 남산면 광판리 1193"},
    ];

    const routeData = [
        ["고속도로 : ", " 서울양양고속도로", "강촌 IC", "5분"],
        ["국도 : ", " 강변북로", "신경춘로", "경춘로"],
    ];

    return (
        <>
            <PageHeader
                bTitle="이용안내"
                detail="오시는 길"
                desc="강아지숲 오시는길을 안내해 드립니다."
            />
            <Contents>
                <Section>
                    <Map src={!isTablet ? mapImage : mMap} alt="강아지숲 위치 지도"/>
                    <MapInfo>
                        <MapTitle>강아지숲</MapTitle>

                        <ContactBox>
                            {contactData.map((item, i) => (
                                <StyledDl key={i} withDivider={i !== 0}>
                                    <IconDd position={item.position}>
                                        {item.link ? <EmailLink href={item.link}>{item.value}</EmailLink> : item.value}
                                    </IconDd>
                                </StyledDl>
                            ))}
                        </ContactBox>

                        <FlexBox>
                            <AddressBox>
                                {addressData.map((item, i) => (
                                    <StyledDl key={i}>
                                   <IconDd position={item.position}>{item.type + " : " + item.value}</IconDd>
                                    </StyledDl>
                                ))}
                            </AddressBox>

                            <InfoBox>
                                {routeData.map((route, i) => (
                                    <StyledDl key={i}>
                                        <IconDd position="-378px -245px">
                                            {route.map((text, idx) => (
                                                <RouteItem key={idx}>{text}</RouteItem>
                                            ))}
                                        </IconDd>
                                    </StyledDl>
                                ))}
                            </InfoBox>
                        </FlexBox>
                    </MapInfo>
                </Section>
            </Contents>
        </>
    );
};

export default Location;
